<div>
  <wl-affcode-selector ngDefaultControl [(ngModel)]="affiliations"></wl-affcode-selector>
</div>
<wl-profile-edit-drop-activity-dialog></wl-profile-edit-drop-activity-dialog>
